import type { ValueOf } from '@weft/utils';

export const ARROW_ICON_DIRECTIONS = {
  UP: 'up',
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export type ArrowIconDirection = ValueOf<typeof ARROW_ICON_DIRECTIONS>;